/**
 * Practice Mode Switch Component
 * Toggle between Math Facts and Word Practice
 */

import { useSettingsStore } from '@stores/settingsStore'

export default function PracticeModeSwitch() {
  const practiceMode = useSettingsStore(state => state.settings.practiceMode)
  const updatePracticeMode = useSettingsStore(state => state.updatePracticeMode)

  return (
    <div className="mode-switch-practice">
      <span className="mode-switch-practice__label" id="modeSwitchLabel">
        Mode
      </span>
      <div
        className="mode-switch-practice__control pill-toggle"
        role="radiogroup"
        aria-labelledby="modeSwitchLabel"
      >
        <label className="mode-switch-practice__option">
          <input
            type="radio"
            name="practiceMode"
            value="math"
            checked={practiceMode === 'math'}
            onChange={() => updatePracticeMode('math')}
          />
          <span className="pill-option">
            <span className="pill-option__full">Math Facts</span>
            <span className="pill-option__short">Math</span>
          </span>
        </label>
        <label className="mode-switch-practice__option">
          <input
            type="radio"
            name="practiceMode"
            value="word"
            checked={practiceMode === 'word'}
            onChange={() => updatePracticeMode('word')}
          />
          <span className="pill-option">
            <span className="pill-option__full">Word Practice</span>
            <span className="pill-option__short">Words</span>
          </span>
        </label>
        <label className="mode-switch-practice__option">
          <input
            type="radio"
            name="practiceMode"
            value="letters"
            checked={practiceMode === 'letters'}
            onChange={() => updatePracticeMode('letters')}
          />
          <span className="pill-option">
            <span className="pill-option__full">Letters</span>
            <span className="pill-option__short">Letters</span>
          </span>
        </label>
      </div>
    </div>
  )
}
